export default __webpack_public_path__ + "static/media/userInstr.4f1a16dd.docx";